import { Dispatch } from "redux";
import { Action, ActionType } from "../actions";
import PluginService from "../../services/pluginService";
import { IBundleConfiguration, IDocumentBundle } from "../../models/configuration/bundles/IBundles";
import { hasDocumentBundlingChanges } from "../../utils/bundlingConfigChangeDetector";

const saveConfigBundleData = (configId: string, updatedBundlingData: Array<IDocumentBundle>, token: string | null) => {
    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({
            type: ActionType.SAVE_CONFIG_BUNDLE_DATA
        });

        const pluginService = new PluginService();

        try {
            if (!updatedBundlingData || updatedBundlingData.length === 0) {
                throw new Error("No Bundles to save");
            }

            const { persistedData } = getState().configDocumentBundles;
            const payloadToSave = {
                Configuration: {
                    Bundling: updatedBundlingData
                }
            };

            const hasChanges = hasDocumentBundlingChanges(payloadToSave, persistedData);
            if (!hasChanges) {
                dispatch({
                    type: ActionType.SAVE_CONFIG_BUNDLE_DATA_SUCCESS,
                    payload: payloadToSave
                });
                return false;
            }

            const requestBody = {
                ConfigurationId: configId,
                Configuration: payloadToSave.Configuration
            };
            await pluginService.saveConfig<IBundleConfiguration>(token, "document-bundling", configId, requestBody);

            dispatch({
                type: ActionType.SAVE_CONFIG_BUNDLE_DATA_SUCCESS,
                payload: payloadToSave
            });

            return true;

        } catch (error) {
            console.log("saveConfigbundleData --> FAILURE");
            const payloadErrorMessage = error instanceof Error
                ? `Failed to save bundles configuration data: (${error.message})`
                : "Failed to save bundles configuration data: (Unknown error)";
            dispatch({
                type: ActionType.SAVE_CONFIG_BUNDLE_DATA_FAILURE,
                payload: payloadErrorMessage
            });
            throw new Error(payloadErrorMessage);
        }
    }
}

export default saveConfigBundleData;